'use client';

import { FormattedMessage } from '@flipster/i18n';
import Formatted from '@flipster/react/design-utils/formatted';
import { css } from '@flipster/styled-system/css';
import { vstack } from '@flipster/styled-system/patterns';
import { BigNumber } from '@flipster/utils/num';

interface Props {
  appliedAprPct: BigNumber;
}

export const AprDisplay = ({ appliedAprPct }: Props) => {
  return (
    <div className={vstack({ gap: 2 })}>
      <span className={css({ textStyle: 'Text/S/Regular', color: 'content.default.level-1' })}>
        <FormattedMessage id='Autogen_common.r251126.s_Your_Max_APR' />
      </span>
      <Formatted.Percent
        value={appliedAprPct}
        precision={2}
        toFixed
        css={{ textStyle: 'Display/L', color: 'content.default.level-5' }}
      />
    </div>
  );
};
